export default "__VITE_ASSET__yW_eMvu1QqHghXJHMLbBbg__";